module.exports = __webpack_public_path__ + "10875ab92bdabe20258647a7dcc2f9b9.png";